import request from "@/api/request";
import { Visit } from "@/interfaces/Visit";
import i18n from "@/i18n.ts";
import { getVisitUid } from "@/utils/storage";

class VisitService {
  static async trackVisit(lang?: "en" | "de" | "fr"): Promise<Visit> {
    const urlParams = new URLSearchParams(location.search);
    const visitUid = getVisitUid() || "";
    const requestParams: { [key: string]: string } = {
      referer: document.referrer,
      lang: lang || (i18n.global.locale as string),
      visit_uid: `${visitUid}`,
    };

    for (const [key, value] of urlParams.entries()) {
      requestParams[key] = value;
    }

    return request.getSimple("/track/visit", requestParams);
  }
}

export default VisitService;
